import React, { useEffect, useState } from "react";
import {
  useGetCommsSettingsDataQuery,
  useGetHeaderSettingsDataQuery,
  useRequestNewHeaderMutation,
} from "../../../../store/slices/settingsSlice";
import Input from "./Input";
import MyModal from "../../../../Common/MyModal";
import { toast } from "react-toastify";

export default function DynamicHeaderInput({
  value = "",
  onChange,
  onLoad,
  placeholder,
  isDisabled,
}: {
  value: string;
  onChange: (value: string) => void;
  onLoad?: (value: string) => void;
  placeholder: string;
  isDisabled?: boolean;
}) {
  const {
    data = {
      allowed: [],
      canRequestDynamicHeaders: false,
      restrictDynamicHeaders: false,
    },
  } = useGetHeaderSettingsDataQuery();
  const [customHeader, setCustomHeader] = useState("");
  const [requestNewHeader] = useRequestNewHeaderMutation();

  const handleRequestNewHeader = async () => {
    const res: any = await requestNewHeader(customHeader);
    if (res.data.success) {
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message);
    }
  };

  const { data: commsSettings } = useGetCommsSettingsDataQuery();

  useEffect(() => {
    if (!commsSettings || !data) return;
    if (!value) {
      const f = onLoad || onChange;
      if (data.restrictDynamicHeaders && data.allowed.length > 0) {
        if (data.allowed.find((a) => a.name === commsSettings?.SmsHeader)) {
          f(commsSettings.SmsHeader);
        } else {
          f(data.allowed[0].name);
        }
      } else {
        f(commsSettings.SmsHeader);
      }
    }
  }, [data, commsSettings]);

  const isValueValid =
    value.length >= 2 &&
    value.length <= 11 &&
    value.replace(/[^a-zA-Z0-9_]/g, "").length === value.length &&
    value[0] !== "_";

  return data.restrictDynamicHeaders ? (
    <div className="d-flex">
      <div className="flex-grow-1 me-2">
        <Input
          isDisabled={isDisabled}
          inputType="select"
          placeholder={placeholder}
          onChange={([v]: any) => onChange(v)}
          value={[value]}
          isOptionDisabled={(o) => !o.data?.approved}
          options={data.allowed?.map((d) => ({
            value: d.name,
            label: d.name,
            data: d,
          }))}
          formatOptionLabel={(o) => (
            <div>
              <span>{o.label}</span>{" "}
              {o.data && (
                <span className="opacity-75">
                  - {o.data?.approved ? "approved" : "pending"}
                </span>
              )}
            </div>
          )}
        />
      </div>
      {data.canRequestDynamicHeaders && !isDisabled && (
        <MyModal
          label="Request new header"
          heading={"Request new header"}
          size="lg"
          buttonClassName="btn-colored px-3 py-0"
        >
          <p className="my-3">Please enter your custom header</p>
          <Input
            value={[customHeader]}
            onChange={(value: string[]) => setCustomHeader(value[0])}
            placeholder="Enter custom header"
            options={undefined}
          />
          <button
            type="button"
            className="btn btn-colored w-100 my-3"
            onClick={handleRequestNewHeader}
          >
            Request
          </button>
        </MyModal>
      )}
    </div>
  ) : (
    <div>
      <Input
        isDisabled={isDisabled}
        placeholder={placeholder}
        onChange={([v]: any) => onChange(v)}
        value={[value]}
        options={undefined}
      />
      {!isValueValid && (
        <div className="alert alert-danger my-3">
          SMS header is invalid. It should be between 2 to 11 characters long
          and can only contain alphabets, numbers and underscores. It can not
          start with an underscore.
        </div>
      )}
    </div>
  );
}
